import { createHelpers } from 'vuex-map-fields';

const { getDashStateField, updateDashStateField } = createHelpers({
	getterType: `getDashStateField`,
	mutationType: `updateDashStateField`,
});


const state = {
	main : {
		date : "",
	}

};

const getters = {
	getDashStateField,

};
// actions
const actions = {

	SET_DASHBOARD_STATE ({commit},data) {
		commit('dashboard_date', data);
	},

};


// mutations
const mutations = {
	updateDashStateField,
	dashboard_date (state, data) {
		state.main.date = data.date;
	},

};


export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
}
